
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 73 74","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.393.887C16.448.887.28 17.055.28 37c0 19.944 16.168 36.113 36.113 36.113S72.507 56.945 72.507 37C72.506 17.055 56.338.887 36.393.887zM20.189 34.773a1.501 1.501 0 012.115-.167L34.5 45.026V14.682a1.5 1.5 0 113 0v29.991l10.042-9.988a1.5 1.5 0 112.115 2.127l-12.6 12.533a1.496 1.496 0 01-2.032.078L20.355 36.89a1.504 1.504 0 01-.166-2.117zm33.517 21.86H18.295a1.5 1.5 0 110-3h35.411a1.5 1.5 0 110 3z","fill":"#fff","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/download.svg